import React from "react";
import { Link } from "react-router-dom";
import "./Gear.css";

import Racket1 from "../assets/Racket1.jpg";
import Racket2 from "../assets/Racket2.webp";
import Racket3 from "../assets/Racket3.webp";
import Racket4 from "../assets/Racket4.webp";

/* STRINGING IMAGES */
import StringingMachine from "../assets/stringing-machine.jpg";
import BG65 from "../assets/b65.jpg";
import BG80 from "../assets/b80.png";
import BG80Titanium from "../assets/b65-titanium.jpg";

const Gear = () => {
  return (
    <div className="gear-page">
      <h1>Coach Recommended Gear</h1>

      {/* ================= RACKETS ================= */}
      <div className="gear-section">
        <h2>Recommended Rackets</h2>

        <div className="gear-grid">
          {/* BEST SELLER */}
          <Link to="/gear/finapi232" className="gear-link">
            <div className="gear-card">
              <div className="image-container">
                <span className="badge best">Best Seller</span>
                <img src={Racket1} alt="Racket" />
              </div>
              <h3>Apacs Finapi 232</h3>
              <p>Powerful racket recommended for attacking players.</p>
            </div>
          </Link>

          {/* 20% OFF */}
          <Link to="/gear/counterattack" className="gear-link">
            <div className="gear-card">
              <div className="image-container">
                <span className="badge discount">20% OFF</span>
                <img src={Racket2} alt="Racket" />
              </div>
              <h3>Apacs Counter Attack</h3>
              <p>Great for speed and quick reactions.</p>
            </div>
          </Link>

          <Link to="/gear/zziggler" className="gear-link">
            <div className="gear-card">
              <div className="image-container">
                <img src={Racket3} alt="Racket" />
              </div>
              <h3>Apacs Z-Ziggler</h3>
              <p>High Tension Capacity and extreme durability.</p>
            </div>
          </Link>

          <Link to="/gear/asgardia" className="gear-link">
            <div className="gear-card">
              <div className="image-container">
                <img src={Racket4} alt="Racket" />
              </div>
              <h3>Apacs Asgardia Lite</h3>
              <p>Improves speed and agility because of its low weight.</p>
            </div>
          </Link>
        </div>
      </div>

      {/* ================= STRINGING SERVICE ================= */}
      <div className="stringing-section">
        <h2 className="stringing-title">
          🏸 Professional <span>Badminton Stringing Services</span>
        </h2>

        <p className="stringing-sub">
          Get your racket strung by our experts with top-quality Yonex strings.
          Express stringing available, done in just 30 mins!
        </p>
        <p>CONTACT US FOR PRICING AND AVAILABILITY - +61 435 245 552.</p>
        <div className="stringing-box">
          {/* HEADER */}
          <div className="stringing-header">
            Express Stringing <span>in 30 Mins</span>
          </div>

          {/* STRING PACKS */}
          <div className="string-pack-row">
            <img src={BG65} alt="BG65" />
            <img src={BG80} alt="BG80" />
            <img src={BG80Titanium} alt="BG80 Titanium" />
          </div>

          {/* FEATURES */}
          <div className="string-features">
            <span>✔ High Repulsion</span>
            <span>✔ Great Control</span>
            <span>✔ Durability</span>
          </div>

          {/* BRAND ROW */}
          <div className="string-brands">
            <span>BG 65</span>
            <span>BG 80</span>
            <span>Titanium</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gear;
